import React from 'react';
import propTypes from 'prop-types';
export const TransferIcon = ({ size = 18, color = 'black' }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      fill={color}
      id="icons"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96.3 96.3"
    >
      <g>
        <g>
          <path
            d="M55.35,43.5c0.7,0.4,1.3,0.6,2.2,0.8c0.2,0,0.4,0.1,0.6,0.1h0.4h0.9l1.5,0.1l3,0.1c2,0.1,4,0.2,5.9,0.2
           c4,0.1,7.9,0.2,11.9,0.2h2.4h1.2h0.6c0.3,0,0.6,0,0.9-0.1c2.5-0.3,4.8-1.8,6.2-3.9c0.3-0.5,0.6-1.1,0.8-1.7
           c0.1-0.3,0.2-0.6,0.3-0.9c0-0.2,0.1-0.3,0.1-0.5l0.1-0.5v-0.3V37v-0.1v-0.3v-0.2v-0.2v-0.3v-1.2l-0.1-4.8l-0.4-19l0.1-1.1
           c0-0.2,0-0.3,0-0.6s0-0.5,0-0.8c-0.1-1.1-0.3-2.1-0.8-3.1c-1-2-2.7-3.6-4.9-4.3c-0.3-0.1-0.5-0.2-0.9-0.2l-0.5-0.1l-0.4-0.1h-0.3
           h-0.1h-0.1h-0.2h-0.5l-2.1-0.1l-4.3-0.2C72.95,0.1,67.15,0,61.35,0h-2.2h-0.3h-0.4c-0.3,0-0.6,0-0.9,0.1c-0.6,0.1-1.2,0.2-1.8,0.4
           c-2.3,0.7-4.3,2.5-5.4,4.7c-0.3,0.5-0.5,1.1-0.7,1.7c-0.1,0.3-0.2,0.6-0.2,1c-0.1,0.4-0.1,0.8-0.1,0.9v0.3v0.3v0.1V10v1.2v4.3
           c0,5.8,0,11.6-0.1,17.3c0,1,0.7,2.6,1.1,3.1c1,1,1.8-0.3,2.4-2.2c2-6.4,2.9-14.3,3.1-22.2l0.1-1.8V9.5V9.4l0,0c0,0.1,0-0.2,0,0.1
           l0,0V9.4V9l0.1-0.3c0.2-0.5,0.5-1,1-1.3s1-0.4,1.6-0.4l3.6,0.1c4.8,0.1,9.6,0.3,14.4,0.4l7.2,0.1h1.8c0.5,0,0.3,0,0.6,0.1
           c0.4,0.1,0.7,0.4,0.9,0.7c0.1,0.2,0.2,0.3,0.2,0.5c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.1,0,0.2s0,0.3,0,0.4v3.6c0,2.4,0.1,4.8,0.2,7.2
           c-0.1,2.4-0.1,4.8-0.2,7.1l-0.1,5.7v2.8l0,0v0.2c0,0.1,0,0.3,0,0.3s0-0.1,0,0s-0.1,0.3-0.2,0.4c-0.3,0.5-0.8,0.8-1.3,0.8h-5.5
           c-3.8,0-7.6,0.1-11.3,0.2l-5.8,0.1l-5,0.2c-0.8,0-1.7-0.5-2.4-1s-1.3-1.2-2.2-1.1c-0.8,0.1-1.6,1.1-1.4,2.9c0.1,0.9,0.5,2,1.4,2.9
           C54.15,42.7,54.65,43.2,55.35,43.5z"
          />
          <path
            d="M16.65,40.1c0.2,0.2,1,0.1,1.5-0.1c0.9-0.4,1.2-1.3,1.2-2.1c0.1-2.8-1-5.1-2.5-6.9c-1.3-1.6-2.6-3.3-4-4.9
           c0.9,0.1,1.9,0.2,2.8,0.2c3.2-0.1,6.4-0.5,9.6-0.7c5.7,2.2,11.6,1,17.3,1.4c0.3,0,0.7-0.7,0.8-1.1c0.3-1-0.1-1.8-0.6-2.4
           c-1.6-2.2-3.6-3.1-5.6-3.3c-4.8-0.6-9.6-1.4-14.4-0.8c-0.6-0.1-1.2-0.2-1.8-0.2c-2.2-0.2-4.3-0.3-6.5-0.2c2.4-2.2,4.6-4.6,6.5-7.3
           c0.7-1.1,0.9-2.5-0.4-3.7c-1.2-1.1-2.7-1.3-3.8-0.5c-1.9,1.4-3.9,2.9-5.5,4.6c-2.7,2.8-5.1,5.7-7.6,8.6l0,0l0,0
           c-1,0.8-1.3,2.2-0.7,3.4l0.2,0.7C6.45,31,12.15,34.9,16.65,40.1z"
          />
          <path
            d="M2.35,87.1c0,0.3,0,0.5,0,0.8c0.1,1.1,0.3,2.1,0.8,3.1c1,2,2.7,3.6,4.9,4.3c0.3,0.1,0.5,0.2,0.9,0.2l0.5,0.1l0.4,0.1h0.3
           h0.1h0.1h0.2h0.5l2.1,0.1l4.3,0.2c5.8,0.2,11.5,0.3,17.3,0.3h2.2h0.3h0.4c0.3,0,0.6,0,0.9-0.1c0.6-0.1,1.2-0.2,1.8-0.4
           c2.4-0.8,4.4-2.5,5.4-4.7c0.3-0.5,0.5-1.1,0.7-1.7c0.1-0.3,0.2-0.6,0.2-1c0.1-0.4,0.1-0.8,0.1-0.9v-0.3v-0.3v-0.1v-0.5v-1.1v-4.3
           c0-5.8,0-11.6,0.1-17.3c0-1-0.7-2.6-1.1-3.1c-1-1-1.8,0.3-2.4,2.2c-2,6.4-2.9,14.3-3.1,22.2l-0.1,1.8v0.2V87l0,0
           c0-0.1,0,0.2,0-0.1l0,0V87v0.4l0,0.3c-0.2,0.5-0.5,1-1,1.3s-1,0.4-1.6,0.4l-3.6-0.1c-4.8-0.1-9.6-0.3-14.4-0.4l-7.2-0.1h-1.8
           c-0.5,0-0.3,0-0.6-0.1c-0.4-0.1-0.7-0.4-0.9-0.7c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.1,0-0.2s0-0.3,0-0.4V83
           c0-2.4-0.1-4.8-0.2-7.2c0.1-2.4,0.1-4.8,0.2-7.1l0.1-5.7v-2.8l0,0V60c0-0.1,0-0.3,0-0.3s0,0.1,0,0s0.1-0.3,0.2-0.4
           c0.3-0.5,0.8-0.8,1.3-0.8h5.5c3.8,0,7.6-0.1,11.3-0.2l5.6-0.2l5-0.2c0.8,0,1.7,0.5,2.4,1s1.3,1.2,2.2,1.1c0.8-0.1,1.6-1.1,1.4-2.9
           c-0.1-0.9-0.5-2-1.4-2.9c-0.4-0.5-1-0.9-1.6-1.3c-0.7-0.4-1.3-0.6-2.2-0.8c-0.2,0-0.4-0.1-0.6-0.1h-0.4h-0.9l-1.5-0.1l-3-0.1
           c-2-0.1-4-0.2-5.9-0.2c-4-0.1-7.9-0.2-11.9-0.2h-2.4h-1.2h-0.6c-0.3,0-0.6,0-0.9,0.1c-2.5,0.3-4.8,1.8-6.2,3.9
           c-0.3,0.5-0.6,1.1-0.8,1.7c-0.1,0.3-0.2,0.6-0.3,0.9c0.2,0.1,0.2,0.3,0.2,0.4l-0.1,0.5v0.3v0.1v0.1v0.3v0.2v0.3v0.3v1.2l0.1,4.8
           l0.4,19.1l-0.1,1.1C2.45,86.8,2.45,86.9,2.35,87.1z"
          />
          <path
            d="M73.55,77c0.6,0.1,1.2,0.2,1.8,0.2c2.2,0.2,4.3,0.3,6.5,0.2c-2.4,2.2-4.6,4.6-6.5,7.3c-0.7,1.1-0.9,2.5,0.4,3.7
           c1.2,1.1,2.7,1.3,3.8,0.5c1.9-1.4,3.9-2.9,5.5-4.6c2.7-2.8,5.1-5.7,7.6-8.6l0,0l0,0c1-0.9,1.3-2.3,0.7-3.5l-0.2-0.6
           c-3.3-6.2-9-10.2-13.5-15.3c-0.2-0.2-1-0.1-1.5,0.1c-0.9,0.4-1.2,1.3-1.2,2.1c-0.1,2.8,1,5.1,2.5,6.9c1.3,1.6,2.6,3.3,4,4.9
           c-0.9-0.1-1.9-0.2-2.8-0.2c-3.2,0.1-6.4,0.5-9.6,0.7c-5.7-2.2-11.6-1-17.3-1.4c-0.3,0-0.7,0.7-0.8,1.1c-0.3,1,0.1,1.8,0.6,2.4
           c1.6,2,3.6,2.9,5.6,3.1C63.85,76.8,68.65,77.7,73.55,77z"
          />
        </g>
      </g>
    </svg>
  );
};
TransferIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
TransferIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
